import {faCheckCircle, faInfo, faWarningDiamond, faXCircle} from '@awesome.me/kit-d4c1b300b9/icons/kit/custom';
import type {AlertIconProps as ChakraAlertIconProps, AlertStatus} from '@chakra-ui/react';
import {AlertIcon as ChakraAlertIcon} from '@chakra-ui/react';
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import type {FontAwesomeIconProps} from '@fortawesome/react-fontawesome';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import type {FC} from 'react';

import {useAlertContext, useStyles} from './context';
import {parts} from './theme/anatomy';

export interface AlertIconProps extends ChakraAlertIconProps {
  status?: AlertStatus;
  size?: FontAwesomeIconProps['size'];
  icon?: IconDefinition;
}
const STATUS_ICONS: Record<AlertStatus, IconDefinition | null> = {
  error: faXCircle,
  info: faInfo,
  success: faCheckCircle,
  warning: faWarningDiamond,
  loading: null,
};

export const AlertIcon: FC<AlertIconProps> = props => {
  const alertContext = useAlertContext();
  const {icon: sx} = useStyles();
  const {status = alertContext.status || `info`, icon = STATUS_ICONS[status], size, children, ...rest} = props;

  const renderIcon = () => {
    return icon ? <FontAwesomeIcon icon={icon} size={size} /> : null;
  };

  return (
    <ChakraAlertIcon {...rest} __css={sx} {...parts.icon.attrs}>
      {children || renderIcon()}
    </ChakraAlertIcon>
  );
};
